import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const route = [
  /** USER */
  {
    path: '/',
    name: 'Main',
    meta: { layout: "userMainLayout"},
    component: () => import('@/pages/user/main/Main.vue'), 
  },
  {
    path: '/login',
    name: 'UserLogin',
    meta: { layout: "userLayout", title:"로그인"},
    component: () => import('@/pages/user/login/UserLogin.vue'), 
  },
  {
    path: '/userJoin',
    name: 'UserJoin',
    meta: { layout: "userLayout", title:"회원가입"},
    component: () => import('@/pages/user/login/UserJoin.vue'), 
  },
  {
    path: '/userMain',
    name: 'UserMain',
    meta: { layout: "userMainLayout"},
    component: () => import('@/pages/user/main/Main.vue'), 
  },
    {
    path: '/osdReport',
    name: 'OsdReport',
    meta: { layout: "userMainLayout"},
    component: () => import('@/pages/user/main/OsdReport.vue'), 
  },
  {
    path: '/introduce',
    name: 'Introduce',
    meta: { layout: "userLayout", title:"탕전실소개"},
    component: () => import('@/pages/user/introduce/Introduce.vue'), 
  },
  {
    path: '/aroundView',
    name: 'AroundView',
    meta: { layout: "userLayout", title:"탕전실소개"},
    component: () => import('@/pages/user/introduce/AroundView.vue'), 
  },
  {
    path: '/locationView',
    name: 'LocationView',
    meta: { layout: "userLayout", title:"탕전실소개"},
    component: () => import('@/pages/user/introduce/LocationView.vue'), 
  },
  {
    path: '/application',
    name: 'ApplictionHerbMedicine',
    meta: { layout: "userLayout", title:"탕제신청"},
    component: () => import('@/pages/user/application/ApplictionHerbMedicine.vue'), 
  },
  {
    path: '/insurance',
    name: 'InsuranceHerbMedicine',
    meta: { layout: "userLayout", title:"접약건보"},
    component: () => import('@/pages/user/application/InsuranceHerbMedicine.vue'), 
  },
  {
    path: '/promiseGoods',
    name: 'ApplictionPromiseGoods',
    meta: { layout: "userLayout", title:"약속상품처방"},
    component: () => import('@/pages/user/application/ApplictionPromiseGoods.vue'), 
  },
  {
    path: '/notice',
    name: 'NoticeList',
    meta: { layout: "userLayout", title:"공지사항"},
    component: () => import('@/pages/user/board/NoticeList.vue'), 
  },
  {
    path: '/qna',
    name: 'QnaList',
    meta: { layout: "userLayout", title:"QnA"},
    component: () => import('@/pages/user/board/QnaList.vue'), 
  },
  {
    path: '/qnaWrite',
    name: 'QnaWrite',
    meta: { layout: "userLayout", title:"QnA등록"},
    component: () => import('@/pages/user/board/QnaWrite.vue'), 
  },
  {
    path: '/qnaDetail/:id',
    name: 'QnaDetail',
    meta: { layout: "userLayout", title:"QnA상세"},
    component: () => import('@/pages/user/board/QnaDetail.vue'),
    props: true // params를 props로 전달 
  },
  {
    path: '/elepantSecretPrescriptionList',
    name: 'ElepantSecretPrescriptionList',
    meta: { layout: "userLayout", title:"코끼리비방사전"},
    component: () => import('@/pages/user/board/ElepantSecretPrescriptionList.vue'), 
  },
  {
    path: '/elepantSecretPrescriptionDetail',
    name: 'ElepantSecretPrescriptionDetail',
    meta: { layout: "userLayout", title:"코끼리비방사전 상세"},
    component: () => import('@/pages/user/board/ElepantSecretPrescriptionDetail.vue'), 
  },
  {
    path: '/formulaQna',
    name: 'FormulaQnaList',
    meta: { layout: "userLayout", title:"처방문답"},
    component: () => import('@/pages/user/board/FormulaQna.vue'), 
  },
  {
    path: '/formulaQnaWrite',
    name: 'FormulaQnaWrite',
    meta: { layout: "userLayout", title:"처방문답 등록"},
    component: () => import('@/pages/user/board/FormulaQnaWrite.vue'), 
  },
  {
    path: '/formulaQnaDetail',
    name: 'FormulaQnaDetail',
    meta: { layout: "userLayout", title:"처방문답 상세"},
    component: () => import('@/pages/user/board/FormulaQnaDetail.vue'), 
  },


  {
    path: '/promisGoodsList',
    name: 'promisGoodsList',
    meta: { layout: "userLayout", title:"약속처방"},
    component: () => import('@/pages/user/promise/PromiseGoodsList.vue'), 
  },

  {
    path: '/PromiseGoodsDetail',
    name: 'PromiseGoodsDetail',
    meta: { layout: "userLayout", title:"약속처방상세"},
    component: () => import('@/pages/user/promise/PromiseGoodsDetail.vue'), 
  },
  {
    path: '/mypage/myInfo',
    name: 'MyInfo',
    meta: { layout: "userLayout", title:"내 정보"},
    component: () => import('@/pages/user/mypage/MyInfo.vue'), 
  },
  {
    path: '/mypage/patientMngt',
    name: 'PatientList',
    meta: { layout: "userLayout", title:"환자관리"},
    component: () => import('@/pages/user/mypage/PatientList.vue'), 
  },
  {
    path: '/mypage/patientDtl',
    name: 'PatientDtl',
    meta: { layout: "userLayout", title:"환자관리 > 환자관리상세"},
    component: () => import('@/pages/user/mypage/PatientListDetail.vue'), 
  },
  {
    path: '/mypage/patientReg',
    name: 'PatientReg',
    meta: { layout: "userLayout", title:"환자관리 > 환자정보등록"},
    component: () => import('@/pages/user/mypage/PatientListReg.vue'), 
  },
  {
    path: '/mypage/myPrescribeList',
    name: 'MyPrescribeList',
    meta: { layout: "userLayout", title:"내 처방관리"},
    component: () => import('@/pages/user/mypage/MyPrescribeList.vue'), 
  },
  {
    path: '/mypage/myPrescribeDtl',
    name: 'MyPrescribeDtl',
    meta: { layout: "userLayout", title:"내 처방 상세정보"},
    component: () => import('@/pages/user/mypage/MyPrescribeDetail.vue'), 
  },
  {
    path: '/mypage/MyPrescribeWrite',
    name: 'MyPrescribeWrite',
    meta: { layout: "userLayout", title:"내 처방 저장"},
    component: () => import('@/pages/user/mypage/MyPrescribeWrite.vue'), 
  },
  {
    path: '/mypage/PrescriptionList',
    name: 'PrescriptionList',
    meta: { layout: "userLayout", title:"처방 내역"},
    component: () => import('@/pages/user/mypage/PrescriptionList.vue'), 
  },
  {
    path: '/mypage/prescriptionDetail',
    name: 'PrescriptionDetail',
    meta: { layout: "userLayout", title:"처방 내역 상세"},
    component: () => import('@/pages/user/mypage/PrescriptionDetail.vue'), 
  },
  {
    path: '/mypage/mySecretPrescriptionList',
    name: 'mySecretPrescriptionList',
    meta: { layout: "userLayout", title:"내 비방사전 관리"},
    component: () => import('@/pages/user/mypage/MySecretPrescriptionList.vue'), 
  },
  {
    path: '/mypage/mySecretPrescriptionWrite',
    name: 'MySecretPrescriptionWrite',
    meta: { layout: "userLayout", title:"내 비방사전 등록"},
    component: () => import('@/pages/user/mypage/MySecretPrescriptionWrite.vue'), 
  },
  {
    path: '/mypage/mySecretPrescriptionDetail',
    name: 'MySecretPrescriptionDetail',
    meta: { layout: "userLayout", title:"내 비방사전 살세"},
    component: () => import('@/pages/user/mypage/MySecretPrescriptionDetail.vue'), 
  },

  //주문 결제 (장바구니)
  {
    path: '/mypage/orderCheckoutList',
    name: 'OrderCheckoutList',
    meta: { layout: "userLayout", title:"장바구니"},
    component: () => import('@/pages/user/mypage/OrderCheckoutList.vue'), 
  },

  /** ADMIN */
  /** 어드민 메인*/
  {
    path: '/admin/login',
    name: 'AdminLogin',
    meta: { layout: "adminLoginLayout"},
    component: () => import('@/pages/admin/login/AdminLogin.vue'), 
  },
  /** 어드민 메인*/
  {
    path: '/admin/main',
    name: 'AdminMain',
    meta: { layout: "adminMainLayout"},
    component: () => import('@/pages/admin/main/AdminMain.vue'), 
  },
  /** 어드민 약재관리*/
  {
    path: '/admin/medicine/medicineMngt',
    name: 'MedicineMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/medicine/MedicineMngt.vue'), 
  },
  {
    path: '/admin/medicine/productCodeMngt',
    name: 'productCodeMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/medicine/ProductCodeMngt.vue'), 
  },
  {
    path: '/admin/medicine/productCodeMngtReg',
    name: 'productCodeMngtReg',
    meta: { layout: "adminLayout"},
    props : true,
    component: () => import('@/pages/admin/medicine/ProductCodeMngtReg.vue'), 
  },  
  {
    path: '/admin/medicine/medicineMngtReg',
    name: 'MedicineMngtReg',
    meta: { layout: "adminLayout"},
    props : true,
    component: () => import('@/pages/admin/medicine/MedicineMngtReg.vue'), 
  },
  {
    path: '/admin/medicine/medicineMngtDtlReg',
    name: 'MedicineMngtDtlReg',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/medicine/MedicineMngtDtlReg.vue'), 
  },
   /** 어드민 약재재고관리*/
   {
    path: '/admin/medicine/MedicineStockMngt',
    name: 'MedicineStockMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/medicineWrhs/MedicineStockMngt.vue'), 
  },

  /** 어드민 약재입고관리*/
  {
    path: '/admin/medicine/MedicineWrhsMngt',
    name: 'MedicineWrhsMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/medicineWrhs/MedicineWrhsMngt.vue'), 
  },
  {
    path: '/admin/medicine/MedicineWrhsMngtReg',
    name: 'MedicineWrhsMngtReg',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/medicineWrhs/MedicineWrhsMngtReg.vue'), 
  },
  {
    path: '/admin/medicine/MedicineWrhsMngtDtl',
    name: 'MedicineWrhsMngtDtl',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/medicineWrhs/MedicineWrhsMngtDtl.vue'), 
  },

    /** 어드민 일별약재사용관리*/
    {
      path: '/admin/medicine/herbUsageReport',
      name: 'herbUsageReport',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/medicineWrhs/HerbUsageReport.vue'),
    },

    /** 어드민 방제사전관리*/  
    {
      path: '/admin/dictionary/dictionaryMngt',
      name: 'DictionaryMngt',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/dictionary/DictionaryMngt.vue'), 
    },
    {
      path: '/admin/dictionary/dictionaryMngtReg',
      name: 'DictionaryMngtReg',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/dictionary/DictionaryMngtReg.vue'), 
    },
    {
      path: '/admin/dictionary/dictionaryMngtDtl',
      name: 'DictionaryMngtDtl',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/dictionary/DictionaryMngtDtl.vue'), 
    },
    {
      path: '/admin/dictionary/insuranceDictionaryMngt',
      name: 'insuranceDictionaryMngt',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/dictionary/InsuranceDictionaryMngt.vue'), 
    },
    {
      path: '/admin/dictionary/insuranceDictionaryMngtReg',
      name: 'InsuranceDictionaryMngtReg',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/dictionary/InsuranceDictionaryMngtReg.vue'), 
    },
    {
      path: '/admin/dictionary/insuranceDictionaryMngtDtl',
      name: 'InsuranceDictionaryMngtDtl',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/dictionary/InsuranceDictionaryMngtDtl.vue'), 
    },
    {
      path: '/admin/dictionary/secretPrescriptionMngt',
      name: 'SecretPrescriptionMngt',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/dictionary/SecretPrescriptionMngt.vue'), 
    },
    {
      path: '/admin/dictionary/secretPrescriptionMngtDetail',
      name: 'SecretPrescriptionMngtDetail',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/dictionary/SecretPrescriptionMngtDetail.vue'), 
    },
  /** 어드민 약속상품관리*/  
    {
      path: '/admin/promise/promiseGoodsMngt',
      name: 'PromiseGoodsMngt',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/promise/promiseGoodsMngt.vue'), 
    },
    {
      path: '/admin/promise/promiseGoodsReg',
      name: 'PromiseGoodsReg',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/promise/promiseGoodsReg.vue'), 
    },
    {
      path: '/admin/promise/promiseGoodsItemList',
      name: 'promiseGoodsItemList',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/promise/promiseGoodsItemList.vue'), 
    },
    {
      path: '/admin/promise/promiseGoodsItemMngt',
      name: 'promiseGoodsItemMngt',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/promise/promiseGoodsItemMngt.vue'), 
    },
    {
      path: '/admin/promise/promiseGoodsWrhsMngt',
      name: 'promiseGoodsWrhsMngt',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/promise/promiseGoodsWrhsMngt.vue'), 
    },
    {
      path: '/admin/promise/promiseGoodsWrhstReg',
      name: 'promiseGoodsWrhstReg',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/promise/promiseGoodsWrhstReg.vue'), 
    },
    {
      path: '/admin/promise/promiseGoodsWrhsWorkMngt',
      name: 'promiseGoodsWrhsWorkMngt',
      meta: { layout: "adminLayout"},
      component: () => import('@/pages/admin/promise/promiseGoodsWrhsWorkMngt.vue'), 
    },    
  /** 어드민 포장관리*/
  {
    path: '/admin/wrapper/WrapperMngt',
    name: 'WrapperMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/wrapper/WrapperMngt.vue'), 
  },
  {
    path: '/admin/wrapper/WrapperMngtReg',
    name: 'WrapperMngtReg',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/wrapper/WrapperMngtReg.vue'), 
  },
  {
    path: '/admin/wrapper/WrapperWrhsMngt',
    name: 'WrapperWrhsMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/wrapper/WrapperWrhsMngt.vue'), 
  },
  {
    path: '/admin/wrapper/WrapperWrhsMngtReg',
    name: 'WrapperWrhsMngtReg',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/wrapper/WrapperWrhsMngtReg.vue'), 
  },
   /** 어드민 업무관리 */
  {
    path: '/admin/work/WorkStatusList',
    name: 'WorkStatusList',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/work/WorkStatusList.vue'), 
  },
  {
    path: '/admin/work/PharmacyMngt',
    name: 'PharmacyMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/work/PharmacyMngt.vue'), 
  },
  {
    path: '/admin/work/WrapperDeliveryMngt',
    name: 'WrapperDeliveryMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/work/WrapperDeliveryMngt.vue'), 
  },
  /** 어드민 회원관리*/
  {
    path: '/admin/userMngt/userMngtList',
    name: 'userMngtList',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/userMngt/UserMngtList.vue'), 
  },
  {
    path: '/admin/userMngt/userMngtDtl',
    name: 'userMngtDtl',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/userMngt/UserMngtDtl.vue'), 
  },
  {
    path: '/admin/userMngt/userDepositList',
    name: 'userDepositList',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/userMngt/UserDepositMngtList.vue'),
  },
  {
    path: '/admin/userMngt/userDepositReg',
    name: 'userDepositReg',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/userMngt/UserDepositReg.vue'),
  },
  {
    path: '/admin/userMngt/userDepositDtl',
    name: 'userDepositDtl',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/userMngt/UserDepositDetail.vue'),
  },
  {
    path: '/admin/userMngt/userPointList',
    name: 'userPointList',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/userMngt/UserPointMngtList.vue'), 
  },
  {
    path: '/admin/userMngt/userPointReg',
    name: 'userPointReg',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/userMngt/UserPointReg.vue'),
  },
  {
    path: '/admin/userMngt/userPointDtl',
    name: 'userPointDtl',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/userMngt/UserPointDetail.vue'),
  },
  /** 어드민 주문결제관리*/  
  {
    path: '/admin/orderPayment/orderTangjunList',
    name: 'orderTangjunList',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/orderPayment/OrderTangjunList.vue'), 
  },
  {
    path: '/admin/orderPayment/orderTangjunDetail',
    name: 'OrderTangjunDetail',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/orderPayment/OrderTangjunDetail.vue'), 
  },
  {
    path: '/admin/orderPayment/orderPromiseList',
    name: 'OrderPromiseList',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/orderPayment/OrderPromiseList.vue'), 
  },
  /** 어드민 시스템관리*/
  {
    path: '/admin/system/codeMngt',
    name: 'CodeMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/system/CodeMngt.vue'), 
  },
  {
    path: '/admin/system/codeMngtRegGrp',
    name: 'CodeMngtRegGrp',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/system/CodeMngtRegGrp.vue'), 
  },
  {
    path: '/admin/system/codeMngtRegDtl',
    name: 'CodeMngtRegDtl',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/system/CodeMngtRegDtl.vue'), 
  },

  /** 어드민 공지사항*/
  {
    path: '/admin/board/noticeMngt',
    name: 'NoticeMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/board/NoticeMngt.vue'), 
  },
  {
    path: '/admin/board/noticeMngtReg',
    name: 'NoticeMngtReg',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/board/NoticeMngtReg.vue'), 
  },
  {
    path: '/admin/board/noticeMngtDtl',
    name: 'NoticeMngtDtl',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/board/NoticeMngtDtl.vue'), 
  },
  {
    path: '/admin/board/qnaMngt',
    name: 'QnaMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/board/QnaMngt.vue'),
  },
  {
    path: '/admin/board/qnaResponse',
    name: 'QnaResponse',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/board/QnaWrite.vue'),
    props: true // params를 props로 전달 
  },
  /** 어드민 둘러보기관리*/  
  {
    path: '/admin/contents/aroundMngt',
    name: 'AroundMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/contents/AroundMngt.vue'), 
  },
  {
    path: '/admin/contents/formulaQnaMngt',
    name: 'FormulaQnaMngt',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/contents/FormulaQnaMngt.vue'), 
  },
  {
    path: '/admin/contents/formulaQnaMngtDetail',
    name: 'FormulaQnaMngtDetail',
    meta: { layout: "adminLayout"},
    component: () => import('@/pages/admin/contents/FormulaQnaMngtDetail.vue'), 
  },   
  // 라우터에 없는 모든 URL에 대해 반응하겠다.
  // {
  //   path: "*", 
  //   name: "NoPage",
  //   component: () => import("@/pages/common/frame/Nopage.vue")
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes: route 
})

// 로그인 없이 들어갈수 있는 페이지
const allowList = ['Main', 'Introduce', 'AroundView','LocationView','UserLogin'];

import store from '../store'

router.beforeEach((to, from, next) => {


    if(to.path.includes('admin')){
      //store.dispatch('commonStore/setCommonStoreInit')
      // const toPath = to.path.split('/').filter(Boolean)[1];
      // const fromPath = from.path.split('/').filter(Boolean)[1];

      next();
    }else if(to.path.includes('userJoin')){
      next();
    }else{
      if(allowList.includes(to.name)){
        // 로그인 없이 들어갈수 있는 페이지 이동의 경우
        store.dispatch('commonStore/setCommonStoreInit');
        store.dispatch('detailSearchInfo/setDetailSearchInfoInit');
        next();
      }else{

        const toPath = to.path.split('/').filter(Boolean)[0];
        const fromPath = from.path.split('/').filter(Boolean)[0];

        console.log("@@@@@ same check toPath :"+toPath);
        console.log("@@@@@ same check fromPath :"+fromPath);

        // 새로고침 또는 최초 진입
        if (!fromPath) {
          next()
          return
        }

        // 같은 메뉴인지 확인
        if(toPath == fromPath){

            // 리스트 화면에서 리스트 화면으로 이동처리 
            const toHas = to.path.includes('List') || to.path.includes('Mngt');
            const fromHas = from.path.includes('List') || from.path.includes('Mngt');

          if(toHas && fromHas ){
            //같은 메뉴에서 다른 리스트 화면 이동
            store.dispatch('commonStore/setCommonStoreInit');
            store.dispatch('detailSearchInfo/setDetailSearchInfoInit');
            store.dispatch('applicationInfo/setRePresciptSeq', '');
          }else{
            //규칙이 다른 메뉴
            if(from.path.includes('Info')){
              store.dispatch('commonStore/setCommonStoreInit');
              store.dispatch('detailSearchInfo/setDetailSearchInfoInit');
              store.dispatch('applicationInfo/setRePresciptSeq', '');
            }
          }
        }else{
          const toPath = to.path.split('/').filter(Boolean)[0];
          const fromPath = from.path.split('/').filter(Boolean)[0];


          // 리스트 화면에서 리스트 화면으로 이동처리
          const toHas = to.path.includes('Detail');
          const fromHas = from.path.includes('List');

          if(toHas && fromHas){
            next();
          }else{
            console.log("@@@@@ toPath :"+toPath);
            console.log("@@@@@ fromPath :"+fromPath);

            const isRePrescript =
                toPath === 'application' &&
                fromPath === 'mypage';

            const isReInsurancePrescript =
                toPath === 'insurance' &&
                fromPath === 'mypage';

            console.log("@@@@@ isRePrescript :"+isRePrescript);

            //다른 메뉴로 화면 이동
            store.dispatch('commonStore/setCommonStoreInit');
            store.dispatch('detailSearchInfo/setDetailSearchInfoInit');

            //재처방이 아닌경우
            if (!isRePrescript && !isReInsurancePrescript) {
              store.dispatch('applicationInfo/setRePresciptSeq', '');
            }
          }

        }

        // 회원정보 체크
        if(store.getters['clinicDoctorInfo/getClinicDoctorId'] != ''){
          next();
        }else{
          next('/login');
        }
      }
      
    }
  // if(store.state.userId != ""){
  //   next();
  // }else{
  //   if(to.name != "AdminLogin"){
  //     next({name:'AdminLogin'});
  //   }else{
  //     next();
  //   }
    
  // }
})

export default router
